<template>
<div class="tabledrag">
    <el-dialog width="350px"
        :visible.sync="dragDialogVisible" 
        :close-on-click-modal="true" 
        :show-close="false"
        :before-close="clickModal">
        <p>拖动改变列位置选择要显示的列</p>
        <el-tree
            ref="dragTreeDom"
            :data="dragTreeData"
            node-key="prop"
            default-expand-all
            @node-drag-start="handleDragStart"
            @node-drag-end="handleDragEnd"
            draggable
            :allow-drop="allowDrop"
            show-checkbox
            :check-strictly="true"
            :default-checked-keys="checkedTree">
        </el-tree>
        <span slot="footer" class="dialog-footer">
            <el-button @click="tableHeadSubmit('cancel')">取 消</el-button>
            <el-button type="primary" @click="tableHeadSubmit('sure')">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
export default {
    name:'tabledrag',
    props:{
        tableHead:{
            type:Array,
            required:true
        },
        dragDialogVisible:{
            type:Boolean,
            required:true,
            default:false,
        },
    },
    data:()=>(
        {  
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            dragTreeData:[],
            checkedTree:[],
        }
    ),
    methods:{
        handleDragStart(draggingNode, ev) {
            this.$refs.dragTreeDom.setChecked(draggingNode.key,false,true);
        },
        handleDragEnd(draggingNode, dropNode, dropType, ev) {
            this.$refs.dragTreeDom.setChecked(draggingNode.key,true,true);
        },
        allowDrop(draggingNode, dropNode, type) {
            if(draggingNode.level != dropNode.level || type === 'inner'){
                return false;
            }else if(draggingNode.parent.id != dropNode.parent.id){
                return false;
            }
            return true;
        },
        clickModal(){
            this.$emit('dragBtnMethod',false)
        },
        tableHeadSubmit(fg){
            if(fg === 'cancel'){
                this.$emit('dragBtnMethod',false)
            }else{
                // **** 这里会请求接口 保存拖动后的数据
                //console.log(this.dragTreeData) // 拖动后数据顺序
                this.$emit('dragBtnMethod',false,JSON.stringify(this.dragTreeData))
            }
        },
        recallfunc(treesdata){ // 递归选中显示的树节点 
            treesdata.forEach(ele=>{
                ele.show && this.checkedTree.push(ele.prop)
                if(!!ele.children && ele.children.length > 0){
                    this.recallfunc(ele.children)
                }
            })
        },
    },
    mounted(){
        // 如果要加拖动列，那么table列表的头渲染每次都要请求一次接口返回的头数据
        this.dragTreeData = this.losseJsonParse(JSON.stringify(this.tableHead))
        this.recallfunc(this.dragTreeData)
    }
}
</script>

<style lang="less" scoped>
.tabledrag{
    /deep/.el-dialog__header{
        padding: 0;
    }
    p{
        margin-bottom: 10px;
    }
}
</style>